import { useTranslation } from 'react-i18next';
import { TableV2 } from '@anytag/shared-atoms';
import { useAnalyticsPermissions } from '@anytag/auth';
import { ConfirmDeleteModal, SocialReconnectModal } from '@anytag/shared-molecules';
import { AnalyticsListProps } from './types';
import { useAnalyticsDeleteAccount, useAnalyticsListTable, useAnalyticsReconnectAccount } from './hooks';

export const AnalyticsList = ({ loading, data = [] }: AnalyticsListProps) => {
  const { t } = useTranslation();
  const { hideAddAnalyticsBtn } = useAnalyticsPermissions();
  const { deleting, deletingAccount, setDeletingAccount, resetDeletingAccount, handleDeleteAccount } =
    useAnalyticsDeleteAccount();
  const {
    reconnected,
    reconnecting,
    reconnectingAccount,
    setReconnectingAccount,
    handleReconnectAccount,
    resetReconnectingAccount
  } = useAnalyticsReconnectAccount();
  const { columns } = useAnalyticsListTable({
    onDelete: setDeletingAccount,
    onReconnectAccount: setReconnectingAccount
  });

  return (
    <>
      <TableV2
        data={data}
        columns={columns}
        loading={loading}
        empty={{
          linkProps: !hideAddAnalyticsBtn ? { to: '/analytics/add', label: t('Analytics.AddAnAnalytics') } : undefined
        }}
        noTopBorderRadius
      />

      <SocialReconnectModal
        reconnected={reconnected}
        reconnecting={reconnecting}
        open={!!reconnectingAccount}
        onClose={resetReconnectingAccount}
        onReconnect={handleReconnectAccount}
        socialMedia={reconnectingAccount?.socialAccountType}
        accounts={[
          ...(reconnectingAccount ? [reconnectingAccount] : []),
          ...(reconnectingAccount?.linkedAccount ? [reconnectingAccount?.linkedAccount] : [])
        ].map((acc) => ({ name: acc.socialAccountName, type: acc.socialAccountType }))}
      />

      <ConfirmDeleteModal
        deleting={deleting}
        onClose={resetDeletingAccount}
        deletingItem={deletingAccount}
        onDelete={handleDeleteAccount}
      />
    </>
  );
};

export * from './utils';
